<template>
	<vs-row>
		<vs-col class="mb-6 md:mb-0" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
		   <Number :typeInput="inputType" v-model="questionsByPage[index].properties.minValue" :label="$t('MODULE.minValue')" :min="0" :max="maxi"  @blur="validateMin"/>
		</vs-col>
		<vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
		   <Number :typeInput="inputType" v-model="questionsByPage[index].properties.maxValue" :label="$t('MODULE.maxValue')" :min="mini" @blur="validateMax"/>
		</vs-col>
	</vs-row>
</template>

<script type="text/javascript">
	import  Number  from '../components/Number.vue';
	import { mapState } from 'vuex';
		
	export default {		
		components: { Number },
		props: ['index'],
		data() {
			return {
				propertyMin: 'minValue',
				propertyMax: 'maxValue'
			}
		},
		watch: {
			maxi: function(value) {
				let valueMax = value
				if(this.inputType === 'currency') {
					this.questionsByPage[this.index].properties.max = String(valueMax).length;
					valueMax = new Intl.NumberFormat("de-DE").format(valueMax);					
				}else if(this.inputType === 'number') {
					this.questionsByPage[this.index].properties.max = String(valueMax).length;
				}				
			},
			mini: function(value) {
				let valueMin = value
				if(this.inputType === 'currency') {
					this.questionsByPage[this.index].properties.min = String(valueMin).length;
					valueMin = new Intl.NumberFormat("de-DE").format(valueMin);
				}else if(this.inputType === 'number') {
					this.questionsByPage[this.index].properties.min = String(valueMin).length;
				}				
			}
		},
		methods: {
			validateMax() {
				if(this.maxi < this.mini) {
					this.questionsByPage[this.index].properties[this.propertyMax] = this.mini;
				}
			},
			validateMin() {
				if(this.mini > this.maxi) {
					this.questionsByPage[this.index].properties[this.propertyMin] = this.maxi;
				}
			}
		},		
		computed: {
			...mapState('resource',['questionsByPage']),
			inputType() {
				return this.questionsByPage[this.index].inputType;
			},
			maxi() {				
				return this.questionsByPage[this.index].properties[this.propertyMax];
			},
			mini() {				
				return this.questionsByPage[this.index].properties[this.propertyMin];
			}
		}
		

	}
</script>